<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;bottom: 12px;height: 325px; top: 263px;left: 270px;transform: translate(-50%, -50%);border: 1px solid #23fffc;border-radius: 10px;}
.title{height: 35px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #23fffc;text-align: center;}
/deep/.el-form-item {margin-bottom: 5px;}
/deep/.el-input__inner {color: #23fffc;}
/deep/.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;background: rgba(10, 17, 43, 0.4);border:none!important;box-shadow:0 0 0 0}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 20px;border: solid 1px #3c818d;}
.el-button--primary {color: #FFF;background-color: rgba(33, 185, 191, 0.6);}
.el-button--default {color: #FFF;background: rgba(10, 17, 43, 0.4);}
/deep/.el-radio-button.is-active .el-radio-button__inner {background: #27898a}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {background: #27898a!important;box-shadow:0 0 0 0}
/deep/.el-tabs__nav{padding: 0px !important;width: 100%;text-align: center;}
/deep/.el-tabs__item {width: 50%;font-size: 14px;color: #FFF;padding: 0;}
/deep/.el-tabs__item.is-active {color:#23fffc;}
/deep/.el-tabs__active-bar {background-color:#23fffc;}
/deep/.el-tab-pane {height: 230px;}
/deep/.el-tab-pane .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.popup-content-type {height: 340px;}
/deep/.popup-content-type .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.el-radio-button__inner .iconfont {top: 2px;height: 40px;width: 40px;display: inline-block;font-size: 36px;position: absolute;left: 0px;color: #23fffc;}
</style>

<template>
  <div>
    <div class="layout" v-drag v-if="flag">
      <p class="title">
        <span>标注</span>
        <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
      </p>
      <div class="popup-content">
        <el-tabs v-model="activeName">
          <el-tab-pane label="点击地图" name="first">
            <el-form ref="form" :model="form" label-width="90px">
              <el-form-item label="请输入标注:">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="请选择图标:">
                <el-radio-group v-model="form.radio" class="markbox">
                   <el-radio-button :label="index" v-for="(item, index) in imglist" :key="index">
                    <img :src="item" alt="">
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click="closePul(false)">取消</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="输入坐标" name="second">
            <el-form ref="form" :model="form2" label-width="90px">
              <el-form-item label="请输入经度:">
                <el-input v-model="form2.longitude"></el-input>
              </el-form-item>
              <el-form-item label="请输入纬度:">
                <el-input v-model="form2.latitude"></el-input>
              </el-form-item>
              <el-form-item label="请输入标注:">
                <el-input v-model="form2.name"></el-input>
              </el-form-item>
              <el-form-item label="请选择图标:">
                <el-radio-group v-model="form2.radio" class="markbox">
                   <el-radio-button :label="index" v-for="(item, index) in imglist" :key="index">
                    <img :src="item" alt="">
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click="closePul(false)">取消</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import {Fill, Stroke, Style, Icon, Text} from 'ol/style'
import Select from 'ol/interaction/Select'
import {click} from 'ol/events/condition'
import {mapState} from 'vuex'
export default {
  data()
  {
    return {
      activeName: 'first',
      imglist: [
        'static/index/map-marker1.png',
        'static/index/map-marker2.png',
        'static/index/map-marker3.png',
        'static/index/map-marker4.png',
        'static/index/map-marker5.png'
      ],
      flag: false,
      form: {
        longitude: '',
        latitude: '',
        name: '',
        radio: '0'
      },
      form2: {
        longitude: '',
        latitude: '',
        name: '',
        radio: '0'
      },
      LayernarData: [],
      markType: '',
      results: ''
    }
  },
  computed: {
    ...mapState({
      curID: state => state.Marktype,
      curID2: state => state.MeasureNum
    })
  },
  watch: {
    curID:
    {
      handler(nval, oval)
      {
        this.markType = nval
      },
      immediate: true
    },
    curID2:
    {
      handler(nval, oval)
      {
        this.results = nval
      },
      immediate: true
    }
  },
  methods: {
    closePul(show)
    {
      this.flag = show
      this.activeName = 'first'
      if (show)
        this.getUserPoint()
      else
        this.clearUserPoint()
    },
    getUserPoint()
    {
      if (localStorage.getItem('username'))
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
          {
            let obj = {
              cmd: 'query',
              _major: 11,
              _minor: 102,
              _exp: `username = '${localStorage.getItem('username')}'`
            }
            window.post.getPost(obj).then((ret1) =>
            {
              this.pointAry = []
              ret1.forEach(item =>
              {
                if (item.prjid === 'Point')
                {
                  let rome = new Feature({
                    geometry: new Point([+item.regcoor.split(',')[0], +item.regcoor.split(',')[1]]) //几何信息
                  })
                  let vector = new VectorSource()
                  vector.addFeature(rome)
                  this.wfsVectorLayer = new VectorLayer({
                    source: vector,
                    style: new Style({
                      fill: new Fill({
                        color: 'rgba(0, 0, 0, 0.4)',
                        width: 1
                      }),
                      stroke: new Stroke({
                        color: '#ffcc33',
                        width: 1
                      }),
                      image: new Icon({
                        src: 'static/index/map-marker1.png'
                      }),
                      text: new Text({
                        textAlign: 'center',
                        textBaseline: 'middle',
                        font: ' 16px serif',
                        text: item.content,
                        offsetx: 0,
                        offsetY: -30,
                        fill: new Fill({
                          color: '#23fffc'
                        })
                      })
                    })
                  })
                  this.pointAry.push(this.wfsVectorLayer)
                  window.map.addLayer(this.wfsVectorLayer)
                }
                // else if (item.prjid === 'LineString')
                // {
                //   let rome = new Feature({
                //     geometry: new LineString([+item.regcoor.split(',')[0], +item.regcoor.split(',')[1]]) //几何信息
                //   })
                //   let vector = new VectorSource()
                //   vector.addFeature(rome)
                //   this.wfsVectorLayer = new VectorLayer({
                //     source: vector,
                //     style: new Style({
                //       fill: new Fill({
                //         color: 'rgba(0, 0, 0, 0.4)',
                //         width: 1
                //       }),
                //       stroke: new Stroke({
                //         color: '#ffcc33',
                //         width: 1
                //       }),
                //       image: new Icon({
                //         src: 'static/index/map-marker1.png'
                //       }),
                //       text: new Text({
                //         textAlign: 'center',
                //         textBaseline: 'middle',
                //         font: ' 16px serif',
                //         text: item.content,
                //         offsetx: 0,
                //         offsetY: -30,
                //         fill: new Fill({
                //           color: '#23fffc'
                //         })
                //       })
                //     })
                //   })
                //   this.pointAry.push(this.wfsVectorLayer)
                //   window.map.addLayer(this.wfsVectorLayer)
                // }
              })
              this.$emit('getpointAry', this.pointAry)
            })
          }
        })
      }
    },
    clearUserPoint()
    {
      if (localStorage.getItem('username'))
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
          {
            if (this.pointAry.length !== 0)
            {
              this.pointAry.forEach(e =>
              {
                e.getSource().clear()
                window.map.removeLayer(e)
              })
            }
          }
        })
      }
    },
    onSubmit()
    {
      if (this.activeName === 'first')
      {
        if (this.form.name)
          this.clickMark(this.form)
        else
          this.$message({message: '请先输入标注信息', type: 'warning', customClass: 'mzindex'})
      }
      else if (this.activeName === 'second')
      {
        if (this.form2.name && this.form2.longitude && this.form2.latitude)
          this.handler()
        else
          this.$message({message: '请先输入坐标以及标注信息', type: 'warning', customClass: 'mzindex'})
      }
    },
    clickMark()
    {
      window.map.on('click', this.handler)
    },
    handler(evt)
    {
      let self = this
      let coordinate = self.activeName === 'first' ? evt.coordinate : [this.form2.longitude, this.form2.latitude]
      var feature = new Feature({
        geometry: new Point(coordinate)
      })
      var vector = new VectorSource()
      var wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 0, 0.4)',
            width: 1
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 1
          }),
          image: new Icon({
            src: self.activeName === 'first' ? self.imglist[self.form.radio] : self.imglist[self.form2.radio]
          }),
          text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            font: ' 16px serif',
            text: self.activeName === 'first' ? self.form.name : self.form2.name,
            offsetx: 0,
            offsetY: -30,
            fill: new Fill({
              color: '#23fffc'
            })
          })
        })
      })
      vector.addFeature(feature)
      self.LayernarData.push(wfsVectorLayer)
      window.map.addLayer(wfsVectorLayer)

      //待定
      let selectClick = new Select({
        condition: click
      })
      window.map.addInteraction(selectClick)
      selectClick.on('select', function(e)
      {
        let obj = {}
        if (self.markType === 'Point')
        {
          obj = {
            text: self.activeName === 'first' ? self.form.name : self.form2.name,
            locationpoine: e.target.getFeatures().array_[0].values_.geometry.flatCoordinates
          }
        }
        else
        {
          obj = {
            text: self.results,
            locationpoine: e.target.getFeatures().array_[0].values_.geometry.flatCoordinates
          }
        }
        self.$emit('setOperation', obj, wfsVectorLayer, evt)
      })
      //待定
      if (self.activeName === 'first')
      {
        // this.form.name = ''
        window.map.un('click', self.handler)
      }
      // else
      // {
      //   self.form2.longitude = ''
      //   self.form2.latitude = ''
      //   self.form2.name = ''
      // }
    },
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
      //关闭弹框
      this.closePul(false)
      this.$store.commit('onMeasureNum', 0)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Mark.vue